<template>
    <div class="envelopes_edit_page">
        <b-breadcrumb :items="breadCrumbs" />
        <div class="row">
            <div class="col-6 offset-3">
                <div style="padding:15px;width:100%;">
                    <form @submit.prevent="updateEnvelope" style="padding:15px;">
                        <div class="form-group">
                            <label for="coa">Model</label>
                            <input
                                :class="{
                  'is-invalid': $v.form.model.$invalid && submit,
                  'is-valid': !$v.form.model.$invalid && submit
                }"
                                type="text"
                                v-model="form.model"
                                class="form-control"
                                id="model"
                                name="model"
                                aria-describedby="model_help"
                                placeholder="i.e: abc123"
                            />
                            <div class="invalid-feedback">
                                Please provide a model
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="name">Name</label>
                            <input
                                :class="{
                  'is-invalid': $v.form.name.$invalid && submit,
                  'is-valid': !$v.form.name.$invalid && submit
                }"
                                type="text"
                                v-model="form.name"
                                class="form-control"
                                id="name"
                                name="name"
                                aria-describedby="name_help"
                                placeholder="i.e: a1"
                            />
                            <div class="invalid-feedback">
                                Please provide a name
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="weight">Weight</label>
                            <input
                                :class="{
                  'is-invalid': $v.form.weight.$invalid && submit,
                  'is-valid': !$v.form.weight.$invalid && submit
                }"
                                type="number"
                                step="0.01"
                                v-model="form.weight"
                                class="form-control"
                                id="weight"
                                name="weight"
                                aria-describedby="weight_help"
                                placeholder="i.e: a1"
                            />
                            <div class="invalid-feedback">
                                Please provide a weight
                            </div>
                        </div>

                        <b-btn variant="success" size="md" class="float-left" type="submit">Update Envelope</b-btn>
                        <b-btn
                            variant="default"
                            size="md"
                            class="float-right"
                            :to="'/envelopes/'"
                        >Cancel
                        </b-btn
                        >
                        <br />
                        <br />
                        <br />
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";

export default {
    name: "envelopes-edit",
    components: {
        DatePicker
    },
    mounted() {
        this.getEnvelopes();
    },
    data() {
        return {
            form: {
                model: "",
                name: "",
                weight: "",
            },
            submit: false,
            breadCrumbs: [
                { text: "Dashboard", to: { name: "dashboard" } },
                { text: "Envelopes", to: { name: "envelopes" } },
                { text: "Edit Envelope", active: true }
            ]
        };
    },
    validations() {
        return {
            form: {
                model: { required },
                name: { required },
                weight: { required },
            }
        };
    },
    methods: {
        getEnvelopes() {
            let loader = this.$loading.show();
            this.$http
            .get(
                this.APIURL +
                this.BRAND +
                "/envelopes/" +
                this.$route.params.id +
                "/edit"
            )
            .then(
                response => {
                    this.form.model = response.data.model;
                    this.form.name = response.data.name;
                    this.form.weight = response.data.weight;
                    loader.hide();
                },
                error => {
                    console.log(error);
                }
            );
        },
        updateEnvelope() {
            this.submit = true;
            if ( !this.$v.$invalid ) {
                //show loader
                let loader = this.$loading.show();
                let envelope = {
                    model: this.form.model,
                    name: this.form.name,
                    weight: this.form.weight,
                };
                this.$http
                .put(
                    this.APIURL + this.BRAND + "/envelopes/" + this.$route.params.id,
                    envelope
                )
                .then(
                    () => {
                        this.$swal({
                            title: "Success!",
                            showConfirmButton: false,
                            timer: 1000,
                            html:
                                "Envelope added successfully, taking you back to envelope list.",
                            type: "success",
                            onClose: () => {
                                loader.hide();
                                this.$router.push({ name: "envelopes" });
                            }
                        });
                    },
                    error => {
                        console.log(error);
                    }
                );
            }
        }
    }
};
</script>
